// extracted by mini-css-extract-plugin
export default {"title":"Patient_title__+ZGzT","table":"Patient_table__Qe5uz","actionButtons":"Patient_actionButtons__1tCdn","openButton":"Patient_openButton__N+b3Y"};